import React, { forwardRef, ComponentProps } from 'react';
import { TableHeader as CarbonTableHeader } from '@carbon/react';

export type TableHeaderProps = ComponentProps<typeof CarbonTableHeader>;

export const TableHeader = forwardRef<HTMLTableCellElement, TableHeaderProps>(
  (props, ref) => <CarbonTableHeader ref={ref} {...props} />
);

TableHeader.displayName = 'TableHeader';
